<template>
    <div class="manufacturer-filter">
        <div class="manufacturer-filter__stilrichtungen">
            <ul class="manufacturer-filter__stilrichtungen--buttons">
                <li>
                    <button
                        @click="activeStil = 0"
                        :class="[
                            'manufacturer-filter__button',
                            !activeStil ? 'active' : '',
                        ]"
                    >
                        {{
                            $translate(
                                "TatyouTheme::Template.categoriesArtistFilterAll"
                            )
                        }}
                    </button>
                </li>
                <li v-for="stil in stils" :key="stil.id">
                    <button
                        @click="activeStil = stil.id"
                        :class="[
                            'manufacturer-filter__button',
                            activeStil === stil.id ? 'active' : '',
                        ]"
                    >
                        {{ stil.details[0].name }}
                    </button>
                </li>
            </ul>
        </div>

        <div class="manufacturer-filter__artists">
            <a
                :class="[
                    'manufacturer-filter__artists--artist',
                    artist.faxNumber.includes(activeStil) || !activeStil
                        ? 'active'
                        : '',
                ]"
                v-for="artist in filteredArtists"
                :title="artist.externalName"
                :key="artist.id"
                :href="
                    manuCategoryLangUrl(
                        artist.manuInformationFromCategories.nameUrl,
                        artist.manuInformationFromCategories.lang
                    )
                "
            >
                <div class="manufacturer-filter__artists--artist-image">
                    <img :src="artist.logo" :alt="artist.externalName" />
                </div>

                <h3>{{ artist.externalName }}</h3>
                <p>{{ artist.town }}, {{ artist.countryName }}</p>
            </a>

            <div
                class="manufacturer-filter__artists-empty"
                v-if="!resultsLength"
            >
                <h3>
                    {{
                        $translate(
                            "TatyouTheme::Template.categoriesFilterNoResults"
                        )
                    }}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ManufacturerFilter",
    props: ["artists", "stils", "manufacturers"],

    data: () => ({
        activeStil: 0,
    }),

    computed: {
        manufacturersWithProfile() {
            return this.manufacturers.filter(
                // id 1 = manufacturer got only allgemeinbereich
                // id 2 = manufacturer got allgemein and profilbereich
                (manuData) => parseInt(manuData.manu.pixmaniaBrandId) === 2
            );
        },

        completeArtists() {
            // artist category IDs are being stored in cdiscount id (marketID 143 in externals)
            return (
                this.manufacturersWithProfile
                    .map((manuData) => {
                        const manu = manuData.manu;

                        try {
                            const manuInformationFromCategories =
                                this.artists.find(
                                    (category) =>
                                        category.id ==
                                        manu.externals.find(
                                            (ex) => ex.marketId === 143
                                        ).value
                                ).details[0];

                            return {
                                ...manu,
                                countryName: manuData.countryName,
                                manuInformationFromCategories,
                            };
                        } catch (e) {
                            console.log(e);
                            return null;
                        }
                    })

                    // filter out nulls
                    .filter((manu) => manu)

                    .sort((a, b) =>
                        a.externalName[0].localeCompare(
                            b.externalName[0],
                            "de",
                            {
                                sensitivity: "base",
                                ignorePunctuation: true,
                            }
                        )
                    )
            );
        },

        filteredArtists() {
            if (!location.search) return this.completeArtists;

            const id = location.search.substr(9, 2);
            if (isNaN(parseInt(id))) return this.completeArtists;

            return this.completeArtists.filter(
                (artist) => artist.neckermannBrandId == id
            );
        },

        resultsLength() {
            return this.filteredArtists.filter((artist) =>
                artist.faxNumber.includes(this.activeStil)
            ).length;
        },
    },
    methods: {
        manuCategoryLangUrl(slug, lng) {
            if (lng === "en") {
                return `/en/tattoo-artists/${slug}`;
            }

            return `/tattoo-artists/${slug}`;
        },
    },
};
</script>

<style scoped>
</style>